import styled from 'styled-components';
import Colors from '../../../enums/Colors';
import { MobileMaxWidth, ResizeMediumWidth } from 'constants/Dimensions';
import { mediaOnlyScreenMaxWidthStr } from 'core/util/cssHelp';
import FullCss, { MediaQuery } from 'core/util/FullCss';

export const IntermediatePageContainer = styled.div(({ ...props }) => () => {
    return new FullCss(
        {
            marginTop: '86px',
            position: 'relative',
            overflow: 'hidden',
        },
        new MediaQuery(mediaOnlyScreenMaxWidthStr(ResizeMediumWidth), {
            marginTop: '60px',
        })
    ).getCss();
});

export const ContentContainer = styled.div(() => {
    return new FullCss({
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingbottom: '70px',
    }).getCss();
});

export const TitleBannerContainer = styled.section<{ highlighted?: boolean; compactBanner?: boolean }>`
    position: relative;
    display: flex;
    width: 100%;
    background: ${Colors.LightBlue2};
    height: ${props => (props.compactBanner ? '132px' : props.highlighted ? '130px' : '183px')};

    @media (max-width: ${ResizeMediumWidth}px) {
        height: ${props => (props.compactBanner ? '132px' : props.highlighted ? '208px' : '142px')};
    }
`;

export const HighlightedContent = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    padding-left: 270px;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 2;

    @media (max-width: 1800px) {
        padding-left: 65px;
    }

    @media (max-width: ${ResizeMediumWidth}px) {
        padding: 24px 20px;
    }
`;

export const HighlightedTitle = styled.h1`
    margin-top: 0;
    font-family: 'Barlow';
    font-size: 40px;
    font-weight: 600;
    line-height: 1.25;
    color: white;

    @media (max-width: ${ResizeMediumWidth}px) {
        font-size: 24px;
        margin-top: 10px;
    }
`;

export const HighlightedSubtitle = styled.p`
    margin-top: 6px;
    font-family: 'Barlow';
    font-size: 16px;
    font-weight: 300;
    line-height: 1.5;
    color: white;
    max-width: 540px;

    @media (max-width: ${ResizeMediumWidth}px) {
        font-size: 14px;
        line-height: 22px;
        max-width: 400px;
    }
`;

export const HighlightedBannerDecoration = styled.img`
    position: absolute;
    top: -80px;
    right: 80px;
    z-index: 1;

    @media (max-width: ${ResizeMediumWidth}px) {
        width: -12px;
        top: -80px;
        right: -80px;
    }
`;

export const HighlightedBreadcrumbContainer = styled.nav`
    display: flex;
    align-items: baseline;
    gap: 10px;
    height: 24px;
    margin-bottom: 0;
    font-family: 'Barlow', sans-serif;
    font-size: 14px;
    line-height: 24px;
    color: ${Colors.White};
`;

export const HighlightedBreadcrumbLink = styled.button`
    padding: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    font: inherit;
    color: inherit;

    &:hover {
        text-decoration: underline;
    }
`;

export const HighlightedBreadcrumbCurrent = styled.span`
    font-weight: 500;
`;

export const HighlightedBreadcrumbSeparator = styled.span`
    opacity: 0.8;
`;

export const HighlightedBannerDot = styled.div`
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    top: 30px;
    left: 130px;
    z-index: 3;

    @media (max-width: 1800px) {
        left: 10px;

    @media (max-width: ${ResizeMediumWidth}px) {
        left: -100px;
    }
`;

export const ReturnButtonContainer = styled.div`
    width: 93px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 93px;

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        padding-left: 0px;
    }
`;

export const BannerTitle1 = styled.p`
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 68.5%;
    color: ${Colors.Blue};

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        font-size: 16px;
        line-height: 11px;
    }
`;

export const BannerTitle2 = styled.p`
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 700;
    font-size: 58px;
    line-height: 70px;
    color: ${Colors.Blue};

    @media only screen and (max-width: ${ResizeMediumWidth}px) {
        font-size: 24px;
        line-height: 22px;
    }
`;

interface IIconSvg {
    transformRule: string;
}

export const IconSvg = styled.img<IIconSvg>`
    position: absolute;
    right: 10%;
    transform: ${props => props.transformRule}; ;
`;

export const CursoLivreIconSvg = styled(IconSvg)`
    top: -124px;
    z-index: 1;

    @media (max-width: ${MobileMaxWidth}px) {
        top: -124px;
        right: 0px;
        transform: translate(59px, 51px);
    }
`;

interface IBreadcrumbContainer {
    isCursoLivre?: boolean;
}

export const BreadcrumbContainer = styled.div<IBreadcrumbContainer>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: ${props => (props.isCursoLivre ? '40px 40px 40px 150px' : '40px 40px 40px 150px')};
    white-space: break-spaces;
`;

interface IBreadcrumbItem {
    currentPage?: boolean;
}
export const BreadcrumbItem = styled.p<IBreadcrumbItem>`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 42px;
    letter-spacing: 0.1px;
    color: ${props => (props.currentPage ? Colors.DarkBlue : Colors.Grey3)};
    &:hover {
        cursor: ${props => (!props.currentPage ? 'pointer' : 'auto')};
        text-decoration: ${props => (!props.currentPage ? 'underline' : 'auto')};
    }
`;

export const Divisor = styled.p`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: ${Colors.Grey3};
`;

export const ChildrenContainer = styled.div`
    padding-left: 3%;
    padding-right: 3%;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        padding-left: 0;
        padding-right: 0;
    }
`;
